import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import {
  AppSegment,
  IconName,
  AppParagraph,
  AppImage,
  AppDivider,
  AppButton,
  ButtonVariant,
} from 'client/ui-building-blocks'

import { getAssetUrl } from 'client/services'
import { usePage } from 'client/hooks'

type Section = {
  icon: IconName
  header: string
  content: {
    text: string
    button: { variant: ButtonVariant; label: string; href: string; target: string }
  }[]
}

const AboutPage = () => {
  const { t } = useTranslation()

  const { navigateTo } = usePage()

  return (
    <div data-testid="about-page">
      <AppSegment maxWidth="medium" centered>
        <AppImage
          src={getAssetUrl('cat-bot-small.jpg')}
          width="250px"
          height="250px"
          rounded
          centered
          alt="logo"
        />
        <AppDivider size="large" />
        {(t('aboutPage.sections', { returnObjects: true }) as Section[]).map(
          (section: Section, i: number) => {
            return (
              <div key={i}>
                <AppSegment
                  headerProps={{
                    text: section.header,
                    marginBottom: 'small',
                    iconProps: {
                      name: section.icon,
                    },
                  }}
                  marginBottom="medium"
                >
                  {section.content.map(({ text, button }, i) => (
                    <>
                      <AppParagraph
                        key={i}
                        text={text}
                        size="small"
                        marginBottom="xsmall"
                      />
                      {button ? (
                        <>
                          <AppButton
                            variant={button.variant || 'success'}
                            text={button.label}
                            onClick={
                              !button.target
                                ? () => {
                                    navigateTo({ path: button.href })
                                  }
                                : undefined
                            }
                            href={button.target ? button.href : undefined}
                            hrefTarget={button.target}
                          />
                          <AppDivider size="small" />
                        </>
                      ) : null}
                    </>
                  ))}
                </AppSegment>
              </div>
            )
          }
        )}
      </AppSegment>
      <AppParagraph text="Can Answer That ? © 2025" centered size="small" />
    </div>
  )
}

export default memo(AboutPage)
